import {FormControlLabel, Radio, RadioGroup} from "@mui/material";
import {Consts} from "../pages/consts";
import SearchDrug from "./SearchDrug";
import AddFreeTextDrugDetails from "./AddFreeTextDrugDetails";
import {useState} from "react";
import {useTranslation} from "react-i18next";

const SpecifyNewDrug = ({patDrugs, allProductNames, allSubstances, onSetSelectedDrug, resetFields, setMessageText,
                          setStrength, setStrengthUnit, handleSetFreeDrugDetails, init = false, language}) => {
  const { t } = useTranslation();
  const [searchOrFree, setSearchOrFree] = useState(Consts.SEARCH);

  return (
    <div className="w3-row w3-margin-bottom" style={{ display: 'flex', alignItems: 'center'}}>
      <div className="w3-col s2 w3-mobile w3-margin-bottom">
        <RadioGroup
          row
          aria-labelledby="search-by-or-free-group"
          name="search-by-or-free-group"
          value={searchOrFree}
          defaultValue={searchOrFree}
          onChange={(e) => setSearchOrFree(e.target.value)}
        >
          <FormControlLabel
            value={Consts.SEARCH}
            control={<Radio />}
            label={<label>{t("search_by")}</label>}
          />
          <FormControlLabel
            value={Consts.FREE_TEXT}
            control={<Radio />}
            label={<label>{t("add_other_drug_details")}</label>}
          />
        </RadioGroup>
      </div>
      <div className="w3-col s10 w3-mobile w3-margin-bottom">
        { searchOrFree === Consts.SEARCH &&
          <SearchDrug
            patDrugs={ patDrugs }
            allProductNames={ allProductNames }
            allSubstances={ allSubstances }
            onSetDrug={ onSetSelectedDrug }
            onResetFields={ resetFields }
            onSetMessageText={ setMessageText }
            onSetStrength={ setStrength }
            onSetStrengthUnit={ setStrengthUnit }
            language={language}
          />
        }
        { searchOrFree === Consts.FREE_TEXT &&
          <AddFreeTextDrugDetails onHandleSetFreeDrugDetails={handleSetFreeDrugDetails} init={init}/>
        }
      </div>
    </div>
  );
}

export default SpecifyNewDrug;